import { motion } from "framer-motion";

export default function PageHero({ kicker, title, subtitle, image, children }) {
  return (
    <section className="relative pt-40 pb-20 md:pt-52 md:pb-28 text-cream overflow-hidden bg-rainforest" data-testid="page-hero">
      {image && (
        <>
          <motion.img
            src={image}
            alt=""
            initial={{ scale: 1.12 }}
            animate={{ scale: 1 }}
            transition={{ duration: 2, ease: "easeOut" }}
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-rainforest/80 to-rainforest/95" />
        </>
      )}
      <div className="relative max-w-[1400px] mx-auto px-6 md:px-12">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          className="overline text-ochre mb-6"
        >
          {kicker}
        </motion.p>
        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.1 }}
          className="font-serif text-4xl sm:text-5xl lg:text-6xl font-light leading-[1.08] max-w-4xl"
        >
          {title}
        </motion.h1>
        {subtitle && (
          <motion.p
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="mt-6 text-cream/75 text-lg font-light max-w-2xl leading-relaxed"
          >
            {subtitle}
          </motion.p>
        )}
        {children}
      </div>
    </section>
  );
}
